import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Patient'
      breadcrumbs={[
        {
          label: 'History',
        },
        {
          label: 'Patient',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/history/patient',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
